import type { RouteRecordRaw } from 'vue-router';
import { RoutePaths } from '@/views/gallery/route-paths';

export const publicRoutes: Array<RouteRecordRaw> = [
  {
    path: '/register/account',
    component: () => import(`./views/register/account/AccountCreation.vue`),
  },
  {
    path: '/register/verified',
    component: () => import(`./views/auth/completed/Completed.vue`),
    meta: { context: 'emailVerified' },
  },
  {
    path: '/auth/password-changed',
    component: () => import(`./views/auth/completed/Completed.vue`),
    meta: { context: 'passwordChanged' },
  },
  {
    path: '/invite/:code',
    component: () => import('./views/gallery/invitations/InviteRedirect.vue'),
  },
  {
    path: `/${RoutePaths.QR_LABEL.STOREFRONT}`,
    component: () => import('@/views/qr-labels/StorefrontQRLabel.vue'),
  },
  {
    path: `/${RoutePaths.QR_LABEL.EXHIBITOR}`,
    component: () => import('@/views/qr-labels/ExhibitorQRLabels.vue'),
  },
  {
    path: `/${RoutePaths.QR_LABEL.LISTING}`,
    component: () => import('@/views/qr-labels/ListingQRLabels.vue'),
  },
];
